module.exports = require('./helpers/bundle-url').getBundleURL('LyihG') + "logo.c51670a8.svg";